/**
 * Shared filter params for the runs-list and runs-trend endpoints
 * (`GET /workflows/test-executions` and `.../test-executions/trend`). Both
 * routes accept the same query shape server-side so the chart and the table
 * beneath it can never disagree about what's being shown — see
 * `apps/api/src/workflows/routes/workflow-test-executions.routes.ts`
 * `parseListFilters`.
 *
 * @module features/workflows/testRunsFilters
 */

export type TestRunsFilterParams = {
  /** `RunTarget.key` values (e.g. `suite:<id>`, `schedule:<id>`, `tag:<raw>`, `adhoc`). */
  targets?: string[];
  statuses?: string[];
  /** User ids, plus the literal `'system'` for runs with no session user. */
  triggeredBy?: string[];
  /** ISO date strings. */
  startedAfter?: string;
  startedBefore?: string;
};

/** Applies the shared filter params to a `URL`'s search params. */
export function applyTestRunsFilterParams(url: URL, filters: TestRunsFilterParams | undefined) {
  if (!filters) return;
  filters.targets?.forEach((value) => url.searchParams.append('targets', value));
  filters.statuses?.forEach((value) => url.searchParams.append('statuses', value));
  filters.triggeredBy?.forEach((value) => url.searchParams.append('triggeredBy', value));
  if (filters.startedAfter) url.searchParams.set('startedAfter', filters.startedAfter);
  if (filters.startedBefore) url.searchParams.set('startedBefore', filters.startedBefore);
}
